import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

const Link = styled(RouterLink)`
  text-decoration: underline !important;
  color: white;
  font-size: 1rem;

  &:hover {
    text-decoration: underline !important;
  }
`;

export default Link;
